import { createContext } from "react";
import { noop } from "@common/helpers/function";

export interface ClientBulkActionPayload {
    action:
        | "note"
        | "team"
        | "priority"
        | "closeStatus"
        | "closeDate"
        | "dueDate"
        | "services"
        | "stage"
        | "assignee";
    value?: string | string[] | number | null;
}

interface ClientBulkActionsContextValue {
    run: (payload: ClientBulkActionPayload) => Promise<void>;
    busy: boolean;
}

export const clientBulkActionsContext =
    createContext<ClientBulkActionsContextValue>({
        run: async () => noop(),
        busy: false,
    });
